<template>
    <div class="dashboard">
        <breadcrumb-bar :crumbs="['Referral/Application Dashboard']"></breadcrumb-bar>
        <div class="row">
            <div class="col-md-7">
                <div class="portlet light">
                    <div class="portlet-title">
                        <div class="caption caption-md">
                            <span class="caption-subject font-dark sbold uppercase">Referral/Application Submission</span></div>
                    </div>
                    <div class="portlet-body">
                        <referral-submission v-if="referralId" :id="referralId"></referral-submission>
                        <p v-else>No referral selected. Please select a referral from the Referral Feed.</p>
                    </div>
                </div>
            </div>
            <referral-feed :movable="false"></referral-feed>
        </div>
    </div>
</template>

<script>
    import ReferralSubmission from "./ReferralSubmission";
    import Breadcrumbs from '@/components/Breadcrumbs'
    import {mapGetters} from 'vuex';

    import ReferralFeed from "../../components/widgets/ReferralFeed";

    export default {
        name: 'ReferralDashboard',
        components: {
            ReferralFeed,
            ReferralSubmission,
            'breadcrumb-bar': Breadcrumbs
        },
        data() {
            return {
                referralId: null
            };
        },
        beforeMount() {
            this.referralId = this.$route.params.id;
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                loading: 'getLoading'
            }),
        },
        watch: {
            '$route.params.id': function (newVal) {
                this.referralId = newVal;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ReferralDashboard.vue?2560f850